import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mock';

const TikTokIcon = () => (
  <svg 
    viewBox="0 0 24 24" 
    width="18" 
    height="18" 
    fill="currentColor"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_arborist-services/artifacts/gqzllqd8_Paysfor%20tout%20seul.png" 
              alt="Paysfor" 
              className="footer-logo"
            />
            <p className="footer-slogan">{companyInfo.slogan}</p>
            <p className="footer-description">
              Services arboricoles, paysagers et forestiers professionnels au Québec.
            </p>
          </div>

          {/* Navigation */}
          <div className="footer-section">
            <h3 className="footer-title">Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/abattage-elagage">Abattage & Élagage</Link></li>
              <li><Link to="/paysagement">Paysagement</Link></li>
              <li><Link to="/travaux-forestiers">Travaux forestiers</Link></li>
              <li><Link to="/realisations">Réalisations</Link></li>
              <li><Link to="/a-propos">À propos</Link></li>
              <li><Link to="/contact">Soumission</Link></li>
            </ul>
          </div>

          {/* Services populaires */}
          <div className="footer-section">
            <h3 className="footer-title">Services populaires</h3>
            <ul className="footer-links">
              <li><Link to="/abattage-arbre-quebec">Abattage d'arbres</Link></li>
              <li><Link to="/elagage-quebec">Élagage</Link></li>
              <li><Link to="/taille-haies-quebec">Taille de haies</Link></li>
              <li><Link to="/essouchage-quebec">Essouchage</Link></li>
              <li><Link to="/amenagement-paysager-quebec">Aménagement paysager</Link></li>
              <li><Link to="/plantation-cedres-quebec">Plantation de cèdres</Link></li>
              <li><Link to="/deboisement-quebec">Déboisement</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={18} />
                <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
              </li>
              <li>
                <Mail size={18} />
                <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>{companyInfo.location}</span>
              </li>
            </ul>
            <div className="footer-service-areas">
              <p><strong>Zone desservie:</strong></p>
              <p>{companyInfo.serviceArea}</p>
              <p style={{ fontSize: '0.875rem', marginTop: 'var(--spacing-xs)', fontStyle: 'italic' }}>
                {companyInfo.serviceAreaNote}
              </p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; {new Date().getFullYear()} Paysfor. Tous droits réservés.</p>
              <p>Un service à la hauteur de vos arbres</p>
            </div>
            
            <div className="footer-social">
              <a 
                href="https://www.facebook.com/profile.php?id=61572315050883" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.instagram.com/paysfor_/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.tiktok.com/@entrepriseforest" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="TikTok"
              >
                <TikTokIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
